import Excel from 'exceljs';
import { saveAs } from 'file-saver';
import { UtilidadesHelper } from 'helpers/UtilidadesHelper';

//  Estilo para encabezados
const headerFill = {
	type: 'pattern',
	pattern: 'solid',
	fgColor: { argb: 'FFFFFF00' }, // Amarillo
};

export const ExportProductMaster = {
	ExportSKUs: async (rows, channelKeys) => {
		try {
			const workbook = new Excel.Workbook();
			const worksheet = workbook.addWorksheet('Product Master');

			console.log(rows);

			// Definir columnas: SKU + Category + canales
			const columns = [
				{ header: 'SKU', key: 'sku', width: 20 },
				{ header: 'Category Manager', key: 'category_owner', width: 25 },
				...channelKeys.map((ch) => ({
					header: ch,
					key: ch,
					width: 15,
				})),
			];

			worksheet.columns = columns;

			// 🔹 Fila 1: Opciones válidas (fusionada)
			const totalColumns = columns.length;
			const optionsText =
				'Opciones válidas → Verdadero: ✔ / SI / V   |   Falso: X / NO / F';

			worksheet.mergeCells(1, 1, 1, totalColumns); // (filaInicio, colInicio, filaFin, colFin)
			const optionsCell = worksheet.getCell(1, 1);
			optionsCell.value = optionsText;

			// Estilo de la celda fusionada
			optionsCell.font = {
				italic: true,
				bold: true,
				color: { argb: 'FF808080' },
			};
			optionsCell.alignment = {
				horizontal: 'center',
				vertical: 'middle',
				wrapText: true,
			};
			worksheet.getRow(1).height = 25;

			// 🔹 Fila 2: Encabezados
			const headerRow = worksheet.addRow(columns.map((c) => c.header));
			headerRow.eachCell((cell) => {
				cell.fill = headerFill;
				cell.font = { bold: true };
				cell.alignment = { vertical: 'middle', horizontal: 'center' };
			});

			// Recorrer todos los SKUs de rows
			rows.forEach((row) => {
				const rowData = {
					sku: row.sku,
					category_owner: row.category_owner || '',
				};

				// ✔ o X según true/false en row[ch]
				channelKeys.forEach((ch) => {
					rowData[ch] = row[ch] ? 'SI' : 'NO';
				});

				const addedRow = worksheet.addRow(rowData);

				// Aplicar estilos ✔ verde / X rojo
				channelKeys.forEach((ch) => {
					const cell = addedRow.getCell(ch);
					cell.alignment = { horizontal: 'center', vertical: 'middle' };

					if (cell.value === 'SI') {
						cell.font = { color: { argb: 'FF008000' }, bold: true }; // Verde
					} else {
						cell.font = { color: { argb: 'FFFF0000' }, bold: true }; // Rojo
					}
				});
			});

			// Generar archivo
			const buffer = await workbook.xlsx.writeBuffer();
			const fileType =
				'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
			const fileExtension = '.xlsx';
			const fechaParaNombre = UtilidadesHelper.fechaParaVistaHoy();

			const blob = new Blob([buffer], { type: fileType });
			saveAs(blob, `ProductMaster_${fechaParaNombre}${fileExtension}`);
		} catch (error) {
			console.log('❌ Error al Exportar Product Master:', error);
		}
	},
};
